@use "foundation/colors";

// A soft surface below the field with caption text and a 16px glyph. The
// default surface is a brand color; on-light is white and on-black is #111.
.pill {
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
  margin: 8px 0;
  padding: 8px;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.3;
  color: colors.$text-primary;
  background-color: rgba(colors.$primary-white, 0.85);
  border-radius: 12px;
}

.on-light {
  background-color: colors.$bg-secondary;
}

.on-black {
  align-items: flex-start;
  gap: 8px;
  color: colors.$text-primary-on-dark;
  background-color: colors.$bg-secondary-on-dark;
}

.icon {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;

  svg {
    width: 16px;
    height: 16px;
  }
}

// The glyph punches its mark out of the disc, so this backdrop paints both
// the mark and — being 2px wider — the ring Lemon needs on a light pill.
.warning .icon {
  background-color: colors.$text-primary;
  border-radius: 50%;

  svg {
    width: 14px;
    height: 14px;
  }

  svg path {
    fill: colors.$secondary-lemon-400;
  }
}
